export default __webpack_public_path__ + "static/media/GrouptopPink.24e8b5fc.png";